"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingThirdPartyToJSON = exports.OnboardingThirdPartyFromJSONTyped = exports.OnboardingThirdPartyFromJSON = void 0;
var runtime_1 = require("../runtime");
function OnboardingThirdPartyFromJSON(json) {
    return OnboardingThirdPartyFromJSONTyped(json, false);
}
exports.OnboardingThirdPartyFromJSON = OnboardingThirdPartyFromJSON;
function OnboardingThirdPartyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'title': json['title'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'publicKey': !(0, runtime_1.exists)(json, 'publicKey') ? undefined : json['publicKey'],
        'secretKey': !(0, runtime_1.exists)(json, 'secretKey') ? undefined : json['secretKey'],
        'exampleHeader': json['exampleHeader'],
    };
}
exports.OnboardingThirdPartyFromJSONTyped = OnboardingThirdPartyFromJSONTyped;
function OnboardingThirdPartyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'title': value.title,
        'description': value.description,
        'publicKey': value.publicKey,
        'secretKey': value.secretKey,
        'exampleHeader': value.exampleHeader,
    };
}
exports.OnboardingThirdPartyToJSON = OnboardingThirdPartyToJSON;
